export const enum TransactionTypes {
  Disbursement = "Disbursement",
  Purchase = "Purchase",
  All = "All",
}
